import React from 'react';

const MagicLoading = () => {
  return (
    <div className="magic-overlay">
      <div className="star-loader">
        {[...Array(9)].map((_, i) => (
          <div
            key={i}
            className="star"
            style={{ animationDelay: `${i * 0.1}s` }}
          >
            ✦
          </div>
        ))}
      </div>
    </div>
  );
};

export default MagicLoading;
